// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__17q4W","spin":"Loader_spin__epn2j","visible":"Loader_visible__S2EWS","hidden":"Loader_hidden__NiSMx"};